var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSentSuccessIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 190.494,
    height: 107.448,
    viewBox: "0 0 190.494 107.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Done",
    transform: "translate(-17 -43.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M57.568,125.734h80.255a6.223,6.223,0,0,0,1.323-.142,6.224,6.224,0,0,0,1.323.142h45.86a6.173,6.173,0,1,0,0-12.347h-5.292a6.173,6.173,0,0,1,0-12.347h16.756a6.173,6.173,0,1,0,0-12.347h-19.4a6.173,6.173,0,0,0,0-12.347H121.948a6.173,6.173,0,1,0,0-12.347H71.679a6.173,6.173,0,0,0,0,12.347H36.4a6.173,6.173,0,0,0,0,12.347H58.45a6.173,6.173,0,1,1,0,12.347H23.173a6.173,6.173,0,1,0,0,12.347H57.568a6.173,6.173,0,1,0,0,12.347Zm143.753,0a6.173,6.173,0,1,0-6.173-6.173A6.173,6.173,0,0,0,201.321,125.734Z",
    transform: "translate(0 -2.244)",
    fill: "#f3f7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M172.5,45v5.292",
    transform: "translate(-18.362)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M172.5,59v5.292",
    transform: "translate(-18.362 -1.653)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M162.5,55h5.292",
    transform: "translate(-17.181 -1.181)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M176.5,55h5.291",
    transform: "translate(-18.834 -1.181)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M89.5,148v3.528",
    transform: "translate(-8.561 -12.162)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M89.5,160v3.528",
    transform: "translate(-8.561 -13.579)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M81.5,156h3.528",
    transform: "translate(-7.616 -13.107)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M93.5,156h3.528",
    transform: "translate(-9.033 -13.107)",
    fill: "none",
    stroke: "#75a4fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M151.062,122.255a40.131,40.131,0,0,0,7.957-16.076,40.715,40.715,0,0,0-49.239-49.021A40.343,40.343,0,0,0,79.738,88.709a40.706,40.706,0,0,0,43.768,48.251,40.324,40.324,0,0,0,15.783-4.859",
    transform: "translate(-7.321 -1.299)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M151.062,122.255a40.131,40.131,0,0,0,7.957-16.076,40.715,40.715,0,0,0-49.239-49.021A40.343,40.343,0,0,0,79.738,88.709a40.706,40.706,0,0,0,43.768,48.251,40.324,40.324,0,0,0,15.783-4.859",
    transform: "translate(-7.321 -1.299)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M150.7,139.659a32.335,32.335,0,0,0,6.324-5.368Z",
    transform: "translate(-15.788 -10.544)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M150.7,139.659a32.335,32.335,0,0,0,6.324-5.368",
    transform: "translate(-15.788 -10.544)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M157.081,99.349q-.378.007-.758.007A42.23,42.23,0,0,1,114.287,60a37.254,37.254,0,1,0,42.794,39.349Z",
    transform: "translate(-7.793 -1.771)",
    fill: "#e8f0fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M108.43,98.912a2.625,2.625,0,0,0-3.738.171,2.694,2.694,0,0,0,.169,3.778l12.452,11.5a3.676,3.676,0,0,0,5.232-.239c.058-.065.058-.065.114-.131l17.77-21.6a2.7,2.7,0,0,0-.343-3.767,2.626,2.626,0,0,0-3.726.347l-16.706,20.312Z",
    transform: "translate(-10.273 -5.078)",
    fill: "#fff",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M108.166,64.413a35.177,35.177,0,0,0-12.112,7.665,35.729,35.729,0,0,0-2.518,2.7M91.11,78.016q-.935,1.413-1.721,2.893Q88.81,82,88.311,83.123",
    transform: "translate(-8.421 -2.292)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M108.405,65.3a1.1,1.1,0,0,0-.774-2.064Zm-5.411,1.32.545.958Zm-7.089,5.313-.766-.793Zm-3.361,1.985a1.1,1.1,0,0,0,1.687,1.42Zm-.662,4.561a1.1,1.1,0,1,0-1.839-1.217Zm-2.64,2.284.973.517h0Zm-2.086,1.766a1.1,1.1,0,1,0,2.015.9Zm20.475-19.294a36.182,36.182,0,0,0-5.181,2.426l1.09,1.916a34,34,0,0,1,4.866-2.278Zm-5.181,2.426a36.481,36.481,0,0,0-7.31,5.478l1.532,1.586a34.289,34.289,0,0,1,6.868-5.148Zm-7.31,5.478a36.819,36.819,0,0,0-2.6,2.778l1.687,1.42a34.607,34.607,0,0,1,2.44-2.612Zm-5.1,6.123q-.964,1.457-1.775,2.983l1.947,1.035q.761-1.432,1.666-2.8Zm-1.775,2.983q-.6,1.126-1.113,2.284l2.015.9q.483-1.087,1.045-2.145Z",
    transform: "translate(-8.273 -2.145)",
    fill: "#75a4fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSentSuccessIcon);
export default __webpack_public_path__ + "static/media/email-sent-success-icon.58adc575c2310dd772fd86370a12290a.svg";
export { ForwardRef as ReactComponent };